import React from 'react';
import { Tooltip as InfoTooltip } from "../../UI/Tooltip/Tooltip";
import Icon from '../../UI/Icon/Icon';

import "./StatisticInfo.sass";

export const StatisticInfo = ({ paymentOptions, ticketsInfo, usersInfo }) => {
  return (
    <>
      <div className="statistics-info">
        <h4 className="statistics-info__title">
          Tickets info<br/>(quantity / paid)
          <InfoTooltip
            className="statistics-info__tooltip"
            description="Refunded, lost and cancelled tickets are not included."
          >
            <Icon name="info" />
          </InfoTooltip>
        </h4>

        <ul className="statistics-info__info-list">
          {paymentOptions.map(pt => {
            return (
              <li className="statistics-info__info-item" key={pt.value}>
                <span>{pt.label}:</span>
                {ticketsInfo[pt.value].amount} / {ticketsInfo[pt.value].paid}
              </li>
            )
          })}

          <li className="statistics-info__info-item statistics-info__info-item--total">
            <strong>Total:</strong>
            {ticketsInfo.totalTickets} / {ticketsInfo.totalPaid}
          </li>
        </ul>
      </div>

      <div className="statistics-info">
        <h4 className="statistics-info__title">Online transactions info</h4>
        <ul className="statistics-info__info-list">
          <li className="statistics-info__info-item">
            <span>Transactions:</span>
            {usersInfo.totalOnlineTransactions}
          </li>
          <li className="statistics-info__info-item">
            <span>Unique buyers:</span>
            {usersInfo.totalUniqeBuyers}
          </li>
          <li className="statistics-info__info-item">
            <span>Average age:</span>
            {usersInfo.averageAge}
          </li>
          <li className="statistics-info__info-item">
            <span>Male:</span>
            {usersInfo.male}
          </li>
          <li className="statistics-info__info-item">
            <span>Female:</span>
            {usersInfo.female}
          </li>
          {usersInfo.undefinedGender > 0 && (
            <li className="statistics-info__info-item">
              <span>Undefined gender:</span>
              {usersInfo.undefinedGender}
            </li>
          )}
        </ul>
      </div>
    </>
  )
}